import React from 'react';

function Modal({ open, onClose, title, children, actions, maxWidth = 'max-w-4xl' }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className={`bg-[var(--axial-surface)] rounded-xl shadow-xl w-full ${maxWidth} max-h-[90vh] flex flex-col border border-[var(--axial-border-strong)]`}>
        <div className="flex items-center justify-between mb-4 px-6 pt-6 flex-shrink-0">
          <h2 className="text-lg font-bold text-[var(--axial-text-primary)]">{title}</h2>
          <button onClick={onClose} className="text-[var(--axial-text-muted)] hover:text-[var(--axial-text-primary)] text-xl font-bold">×</button>
        </div>
        <div className="overflow-y-auto flex-1 px-6">{children}</div>
        {actions && <div className="flex justify-end gap-2 px-6 pb-6 pt-4 flex-shrink-0 border-t border-[var(--axial-border)]">{actions}</div>}
      </div>
    </div>
  );
}

export default Modal;
